/**
 * Menu configuration for the Header.
 * Accepts userStore (MobX) to check permissions via computed properties.
 */
export const getMenus = (userStore) => [
  {
    label: 'Shipments',
    subMenus: [
      {
        link: '/deliveries',
        label: 'Shipments',
      },
      {
        link: `/search`,
        label: 'Search',
      },
      {
        link: `/batch`,
        label: userStore.isStoreUser ? 'Create' : 'Batch',
        disabled: () => !(!userStore.isReadOnly || userStore.isStoreUser),
      },
    ],
  },
  {
    label: 'Claims',
    subMenus: [
      {
        link: `/claims`,
        label: 'Claims',
        disabled: () => !userStore.isClaimsEnabled,
      },
    ],
  },
  {
    label: 'Reports',
    subMenus: [
      {
        link: `/reports`,
        label: 'Reports',
      },
    ],
  },
  {
    label: 'Dashboards',
    subMenus: [
      {
        link: `/dashboards`,
        label: 'Dashboards',
        disabled: () => !userStore.canShowDashboards,
      },
    ],
  },
];
